import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { useTranslation } from "react-i18next";

import { complist } from "../../components/funtionsBD/Mainservice";
import { currentAppLanguage } from "../../utils/appLanguages";

const style = {
  position: "absolute",
  top: "56%",
  left: "49.2%",
  transform: "translate(-50%, -50%)",
  width: { xs: "95%", sm: "385px" },
  bgcolor: "#f3f8fa",
  p: 1,
  borderRadius: "10px",
  border: "none",
  textAlign: "center",
  outline: "none  ",
};

const Wizard2 = ({ open, setopen, handleadd, cbnum, cbmin }) => {
  const [list, setlist] = useState();
  const { t } = useTranslation();
  const currentlng = currentAppLanguage();
  console.log(cbnum, cbmin);
  useEffect(() => {
    typelist();
  }, []);

  useEffect(() => {
    setlist(
      list?.map((d) => ({
        ...d,
        steps: 0,
        duration: cbmin,
      }))
    );
  }, [cbnum]);

  console.log(list);
  const typelist = async () => {
    try {
      const response = await complist();

      const data = response.data.data.map((d) => ({
        ...d,
        steps: 0,
        duration: cbmin,
      }));
      setlist(data);
    } catch (error) {
      console.log(error);
    }
  };
  const calculateTotalTime = (list) => {
    return list?.reduce((acc, curr) => acc + parseInt(curr.steps || 0), 0);
  };
  const handlevalueadd = (i) => {
    const currentTotal = calculateTotalTime(list);
    console.log(currentTotal);

    const newMin = parseInt(i.steps + 1);
    console.log(newMin);

    const totalWithNewValue = currentTotal - parseInt(i.min || 0) + 1;
    console.log(totalWithNewValue);

    if (!totalWithNewValue || totalWithNewValue <= cbnum) {
      const updatedList = list.map((item) =>
        item.cb_id === i.cb_id ? { ...item, steps: newMin } : item
      );
      console.log(updatedList);

      setlist(updatedList);
    } else {
      alert(`${t("timeexceed")} ${cbnum} ${t("minute")}.`);
    }
  };
  const handlevalueminus = (i) => {
    if (i.steps !== 0) {
      const updatedList = list.map((item) =>
        item.cb_id === i.cb_id ? { ...item, steps: i.steps - 1 } : item
      );
      setlist(updatedList);
    }
  };
  const handlews = () => {
    handleadd(
      list.filter((l) => l.steps > 0),
      calculateTotalTime(list)
    );
    setopen(false);
  };
  return (
    <>
      <Modal
        open={open}
        onClose={() => setopen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        style={{
          backgroundColor: "rgb(0, 0, 0, 0)",
        }}
      >
        <Box sx={style}>
          <h1 className="wizard_title">{t("competencyblock")}</h1>
          <p>
            {calculateTotalTime(list)}/{cbnum}
          </p>
          {list?.map((i, index) => (
            <div className="wizard_setup" key={index}>
              <p>{i[`cb_name_${currentlng}`]}</p>
              <div className="wizard_cb_add">
                <p
                  className="wizard_cb_action"
                  onClick={() => handlevalueminus(i)}
                >
                  -
                </p>

                <p className="wizard_cb_num">{i.steps}</p>
                <p
                  className="wizard_cb_action"
                  onClick={() => handlevalueadd(i)}
                >
                  +
                </p>
              </div>
            </div>
          ))}
          <div className="input-detail">
            <button className="w-100" onClick={handlews}>
              {t("add")}
            </button>
          </div>
        </Box>
      </Modal>
    </>
  );
};
export default Wizard2;
